export function getColumn(data, columnName) {
  return data.map(function (item) {
    return item[columnName] * 1;
  });
}
//# sourceMappingURL=util.js.map